import { recordCostEvent } from "./cost_telemetry"

let requestCount = 0
let transferBytes = 0
const sampleRate = 0.01

function paidMediaResource(entry) {
  if (!["img", "video"].includes(entry.initiatorType)) return false

  const url = entry.name.toLowerCase()
  return url.includes("amazonaws.com") || url.includes("/rails/active_storage/")
}

function capture(entries) {
  entries.filter(paidMediaResource).forEach((entry) => {
    requestCount += 1
    transferBytes += entry.transferSize || 0
  })
}

function flush() {
  if (requestCount === 0) return

  recordCostEvent("media_requests", {
    context: `/${window.location.pathname.split("/").filter(Boolean)[0] || "home"}`,
    count: requestCount,
    transfer_bytes: transferBytes,
    sample_rate: sampleRate
  })
  requestCount = 0
  transferBytes = 0
}

if ("PerformanceObserver" in window && Math.random() < sampleRate) {
  try {
    const observer = new PerformanceObserver((list) => capture(list.getEntries()))
    observer.observe({ type: "resource", buffered: true })
    window.setInterval(flush, 30000)
    window.addEventListener("pagehide", flush)
  } catch (_) {}
}
